import store from "@/store/store";
import axios from "axios";
let http = axios.create();

http.interceptors.request.use(
  (config) => {
    let userInfo = localStorage.getItem("session_login") ? JSON.parse(localStorage.getItem("session_login")) : {};
    let token = userInfo.access_token;
    config.baseURL = process.env.VUE_APP_API_URL;
    config.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    let userInfo = JSON.parse(localStorage.getItem("session_login"));
    if (userInfo) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("session_login");
        window.location.replace("/login");
      }
      if (axios.isCancel(error)) {
        store.commit("user/RESET_LOADING");
      }
      return Promise.reject(error);
    }
  }
);

export default http;
